import { format } from 'date-fns'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import UserSelector from '../components/UserSelector'
import Activity from '../components/Activity'
import { useGetNeuroReportsQuery } from '../redux/api/brainApi'
import { useGetPatientByIdQuery } from '../redux/api/patientApi'
import DataTable from './DataTable'
import DiagnosisReport from './DiagnosisReport'
import Insights from './Insights'
import { Alert } from 'react-bootstrap'

const Neuro = () => {
  const today = format(new Date(), 'yyyy-MM-dd')
  const [date, setDate] = useState(today)

  const { selectedUser } = useSelector((state) => state.user)

  const { data: reports, isLoading: loadingReports, error, isError } = useGetNeuroReportsQuery({ userId: selectedUser?.id }, { skip: !selectedUser })

  const {
    data: patientData,
    isLoading: loadingPatient,
    error: patientError,
    isError: isPatientError,
  } = useGetPatientByIdQuery({ id: selectedUser?.id, date }, { skip: !selectedUser })

  return (
    <div>
      <div className='dashboard-heading'>
        <div className='content-container m-0'>
          <h2>Neuro Diagnosis</h2>
          <p className='m-0'>Upload and check diagnosis reports.</p>
        </div>
        <Activity />
      </div>

      <div className='d-flex gap-2 align-items-center justify-content-between'>
        <div className='d-flex gap-2 align-items-center'>
          <UserSelector />
          <fieldset>
            <label htmlFor='date'>Date:</label>
            <input type='date' name='date' id='date' value={date} onChange={(e) => setDate(e.target.value)} style={{ maxWidth: 150 }} />
          </fieldset>
        </div>
      </div>

      <div>
        {loadingPatient ? (
          <div className='text-center p-4'>Loading...</div>
        ) : isPatientError ? (
          <div className='text-center p-4 dashboard-cards h-100 d-flex align-items-center justify-content-center text-secondary'>
            {patientError?.data.error || patientError.message}
          </div>
        ) : patientData ? (
          <div className='dashboard-cards p-4'>
            <DataTable data={patientData} />
          </div>
        ) : null}
      </div>

      <div>
        {loadingReports ? (
          <div className='text-center p-4'>Loading...</div>
        ) : isError ? (
          <div className='text-center p-4 dashboard-cards h-100 d-flex align-items-center justify-content-center text-secondary'>
            {error?.data.error || error.message}
          </div>
        ) : reports ? (
          <>
            <Alert variant='warning' className='mt-3' style={{ borderRadius: 16 }}>
              {reports.disclaimer}
            </Alert>
            <Insights insights={reports.eeg_clinic_insght} />
            <DiagnosisReport result={reports.results} />
          </>
        ) : null}
      </div>
    </div>
  )
}

export default Neuro
